<!-- <ion-header>
  <ion-row class="ion-align-items-center ion-justify-content-center">
    <ion-col sizeLg="10">
      <ion-toolbar>
        <ion-buttons slot="start">
          <img src="assets/imgs/logo.svg" alt="" />
        </ion-buttons>
        <ion-buttons slot="end" id="dot" (click)="presentPopover($event)">
          <ion-button fill="clear">
            <ion-icon
              name="ellipsis-horizontal-outline"
              slot="icon-only"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" class="tbtns">
          <ion-button id="login">
            LOG IN
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" class="tbtns">
          <ion-button id="signup">
            SIGNUP
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-col>
  </ion-row>
</ion-header> -->

<site-header></site-header>

<ion-content>
  <ion-row
    class="ion-align-items-center ion-justify-content-center"
    style="height: 100%;"
  >
    <ion-col sizeLg="10" class="inside-col">
      <div class="holder">
        <div class="the-card">
          <ion-row>
            <ion-col size="6" class="flex fd jc-between">
              <div class="content ion-padding-vertical">
                <div class="ion-padding-horizontal">
                  <h2>Contact Us</h2>
                </div>
                <div class="the-form">
                  <ion-item>
                    <ion-input
                      type="email"
                      placeholder="Please enter your email address"
                    >
                    </ion-input>
                  </ion-item>
                  <ion-item>
                    <ion-input type="text" placeholder="Your name"></ion-input>
                  </ion-item>
                </div>
              </div>

              <div class="btn-holder ion-padding-vertical">
                <ion-button expand="block">
                  Submit
                </ion-button>
              </div>
            </ion-col>
            <ion-col size="6" class="map-col">
              <ion-row>
                <ion-col size="2" class="flex al-center jc-center">
                  <ion-icon name="location-outline"></ion-icon>
                </ion-col>
                <ion-col size="10">
                  <h3>Company Address</h3>
                  <p>7126 Sotheby Way, Lorton Virginia , US</p>
                </ion-col>
              </ion-row>
              <!-- <ion-row>
                <ion-col size="2" class="flex al-center jc-center">
                  <ion-icon name="location-outline"></ion-icon>
                </ion-col>
                <ion-col size="10">
                  <h3>Address</h3>
                  <p>ABC Road, Def, ghijklmnop</p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="2" class="flex al-center jc-center">
                  <ion-icon name="location-outline"></ion-icon>
                </ion-col>
                <ion-col size="10">
                  <h3>Address</h3>
                  <p>ABC Road, Def, ghijklmnop</p>
                </ion-col>
              </ion-row> -->
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
